const serverConfig = {
    serverUrl: 'https://api.karib-tech.com',
    authToken: 'valid_token',
    apiKey: 'your-api-key',
};

export default serverConfig;